import { useContext, createContext, useEffect, useState, useCallback } from "react";
import Cookies from "js-cookie";

const CookiesContext = createContext();

const CookieDateValidThreeDays = 3;
const CookieDateCheckThreeMin = 180000;

const CookiesProvider = ({ children }) => {
	
	const [lastVisitCookieDate, setLastVisitCookieDate] = useState(undefined);
	
	Cookies.remove('date'); // removing prev cookie value, remove in 2026

	const resetCookieDateRefresh = useCallback(() => {

		window.location.reload(); // To make sure people get the update version
		const browserViewDate = new Date();
		const newCookie = Cookies.set("lastVisitDate", browserViewDate, {
			expires: CookieDateValidThreeDays,
		});

		setLastVisitCookieDate(newCookie)

	}, []);

	const checkDateCookie = useCallback(() => {
		const oldCookie = Cookies.get("lastVisitDate");

		if(!oldCookie) {
			resetCookieDateRefresh();
		} else {
			setLastVisitCookieDate(oldCookie)
		}

	},[resetCookieDateRefresh])

	useEffect(() => { // firing every 3min to check if lastVisitDate is in the cookie session

		const interval = setInterval(() => {
		 checkDateCookie();
		}, CookieDateCheckThreeMin);
	
		return () => clearInterval(interval);

	  }, [checkDateCookie]);

	
	useEffect(() => { // initial loading to input lastVisitDate valid for 3 days
		checkDateCookie();
	}, [checkDateCookie])

  return <CookiesContext.Provider value={{lastVisitCookieDate, resetCookieDateRefresh}}>{children}</CookiesContext.Provider>;
};

export default CookiesProvider;

export const useCookies = () => {
  return useContext(CookiesContext);
};